var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.983 67.807l.042-.04V52.064c-.084-3.14-.084-6.32 0-9.461h-2.812c-.084.157-.252.157-.377.157-6.379.746-11.876 3.219-16.282 7.577C2.518 55.204 0 61.054 0 67.846h26.983v-.039z",
    fill: "#ECECF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.95 93.05V67.846H.043C0 68.004 0 68.202 0 68.4c.335 7.834 3.683 14.284 10.17 19.19 4.896 3.719 10.503 5.579 16.823 5.5.012-.012.02-.025.032-.037-.025-.002-.05-.001-.074-.004",
    fill: "#E6E6F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.013 118.401a.433.433 0 00-.14-.064.458.458 0 01.14.104c-8.965 0-17.93 0-26.895-.04-.015.024-.027.052-.047.071-.02.017-.048.026-.071.039v25.026c.025.003.05.002.075.004 1.283.107 2.566-.008 3.808-.201 9.455-1.497 16.377-6.225 20.598-14.222 1.772-3.389 2.659-6.935 2.532-10.717",
    fill: "#ECECF7",
    fillOpacity: 0.579
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.076 118.298c8.983.039 17.966.039 26.949.039a.458.458 0 00-.14-.103c-.122-.034-.245-.015-.367-.015l-.287-.007a1.572 1.572 0 01-.136.007H17.72c-.236 0-.416-.028-.546-.11-.15-.096-.235-.263-.258-.557-.042-.707-.17-1.413-.296-2.12-1.396-7.418-8.5-12.912-16.621-12.873v15.699c.048-.039.096-.072.147-.1-.008.021-.012.04-.02.061-.011.031-.034.053-.05.079",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.063 15.842a.444.444 0 00-.14-.064.477.477 0 01.14.104c-8.965 0-17.93 0-26.895-.04-.016.025-.027.053-.048.072-.019.017-.047.026-.07.039v25.026c.025.002.05.001.074.004 1.284.106 2.567-.008 3.809-.201 9.455-1.498 16.377-6.225 20.597-14.223 1.773-3.388 2.66-6.934 2.533-10.717",
    fill: "#ECECF7",
    fillOpacity: 0.579
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.126 15.739c8.983.039 17.966.04 26.949.04a.487.487 0 00-.14-.104c-.123-.034-.245-.014-.368-.014-.095-.004-.19-.005-.286-.008a1.34 1.34 0 01-.137.008H71.77c-.236 0-.415-.028-.545-.111-.15-.096-.235-.263-.258-.557-.043-.706-.17-1.413-.296-2.12C69.275 5.457 62.17-.039 54.05 0v15.7a.998.998 0 01.147-.1c-.008.02-.012.04-.02.06-.012.032-.034.053-.051.079",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.008 67.807l.042-.04V52.064c-.084-3.14-.084-6.32 0-9.461h-2.812c-.084.157-.252.157-.377.157-6.379.746-11.876 3.219-16.283 7.577-5.035 4.868-7.553 10.718-7.553 17.51h26.983v-.039z",
    fill: "#ECECF7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.976 93.05V67.846h-26.91c-.041.157-.041.355-.041.553.335 7.834 3.683 14.284 10.17 19.19 4.896 3.719 10.504 5.579 16.823 5.5.012-.012.02-.025.032-.037-.024-.002-.05-.001-.074-.004",
    fill: "#E6E6F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.063 67.91a.444.444 0 00-.14-.063.468.468 0 01.14.104c-8.965 0-17.93 0-26.895-.04-.016.024-.027.052-.048.07-.019.018-.047.027-.07.04v25.026l.074.004c1.284.107 2.567-.008 3.809-.201 9.455-1.497 16.377-6.225 20.597-14.223 1.773-3.388 2.66-6.933 2.533-10.716",
    fill: "#ECECF7",
    fillOpacity: 0.579
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.126 67.807c8.983.04 17.966.04 26.949.04a.473.473 0 00-.14-.104c-.123-.033-.245-.015-.368-.015l-.286-.007a1.464 1.464 0 01-.137.007H71.77c-.236 0-.415-.027-.545-.11-.15-.095-.235-.263-.258-.556-.043-.707-.17-1.414-.296-2.12-1.396-7.418-8.501-12.913-16.621-12.873v15.699a.969.969 0 01.147-.1c-.008.02-.012.04-.02.06-.012.032-.034.053-.051.08",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.008 118.298l.042-.04v-15.704a177.677 177.677 0 010-9.462h-2.812c-.084.157-.252.157-.377.157-6.379.746-11.876 3.22-16.283 7.577-5.035 4.869-7.553 10.719-7.553 17.511h26.983v-.039z",
    fill: "#ECECF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.976 143.54V118.337h-26.91c-.041.158-.041.356-.041.554.335 7.834 3.683 14.283 10.17 19.189 4.896 3.719 10.504 5.578 16.823 5.5.012-.013.02-.025.032-.037-.024-.002-.05-.001-.074-.003",
    fill: "#E6E6F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.063 118.401a.437.437 0 00-.14-.064.463.463 0 01.14.104c-8.965 0-17.93 0-26.895-.04-.016.024-.027.052-.048.071-.019.017-.047.026-.07.039v25.026c.025.003.05.002.074.004 1.284.107 2.567-.008 3.809-.201 9.455-1.497 16.377-6.225 20.597-14.222 1.773-3.389 2.66-6.935 2.533-10.717",
    fill: "#ECECF7",
    fillOpacity: 0.579
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.126 118.298c8.983.039 17.966.039 26.949.039a.463.463 0 00-.14-.103c-.123-.034-.245-.015-.368-.015l-.286-.007a1.573 1.573 0 01-.137.007H71.77c-.236 0-.415-.028-.545-.11-.15-.096-.235-.263-.258-.557-.043-.707-.17-1.413-.296-2.12-1.396-7.418-8.501-12.912-16.621-12.873v15.699a.998.998 0 01.147-.1c-.008.021-.012.04-.02.061-.012.031-.034.053-.051.079",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPattern);
export default __webpack_public_path__ + "static/media/sidebar-pattern.f06bb7da.svg";
export { ForwardRef as ReactComponent };